module.exports = __webpack_public_path__ + "static/img/login_title.ad345bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_title.png
// module id = 39nC
// module chunks = 42